<h1 mat-dialog-title>{{ title }}</h1>

<div mat-dialog-content>
  @if (formwithdraw) {
    <form
      [formGroup]="formwithdraw"
      autocomplete="off"
      class="withdraw-form">

      <!-- Withdraw reason -->
      <mat-form-field appearance="outline" class="full">
        <mat-label>Withdraw Reason</mat-label>

        <mat-select formControlName="eventtype">
          <mat-option value="">-- Select One --</mat-option>

          @for (item of data.reasonoptions; track item.value) {
            <mat-option [value]="item.value">
              {{ item.label }}
            </mat-option>
          }
        </mat-select>

        @if (formwithdraw.get('eventtype')?.hasError('required')) {
          <mat-error>Reason type required</mat-error>
        }
      </mat-form-field>

      <!-- Other reason -->
      @if (formwithdraw.get('eventtype')?.value === '700000003') {
        <mat-form-field appearance="outline" class="full">
          <mat-label>Other Reason</mat-label>
          <textarea
            matInput
            formControlName="otherreason"
            maxlength="2000"
            rows="5"
            placeholder="Enter reason for other">
          </textarea>
        </mat-form-field>
      }

    </form>
  }
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-button type="button" (click)="onClickCancel()">Cancel</button>

  <button
    mat-flat-button
    color="accent"
    type="button"
    (click)="onSave()"
    [mat-dialog-close]="data"
    [disabled]="formwithdraw.pristine || formwithdraw.invalid">
    Save
  </button>
</div>
